import React from 'react';

import { useBlockUser, useUnblockUser } from '../../data';
import Actions from './Actions';
import { STATUS_ACTIVE } from '../../constants';

export const UserActions = ({ data, onEdit, onDuplicate }) => {
  const isActive = data?.status.id === STATUS_ACTIVE;

  const [blockUser] = useBlockUser();
  const [unblockUser] = useUnblockUser();

  const handleBlock = () => {
    blockUser(data);
  };

  const handleUnBlock = () => {
    unblockUser(data);
  };

  const handleEdit = () => {
    onEdit(data);
  };

  const handleDuplicate = () => {
    onDuplicate(data);
  };

  return (
    <Actions
      isActive={isActive}
      onEdit={handleEdit}
      onDuplicate={handleDuplicate}
      onBlock={handleBlock}
      onUnBlock={handleUnBlock}
    />
  );
};

export default UserActions;
